/**
 * View Mode Selector
 * Toggle between different plot viewing modes
 */

import React from 'react';
import { ToggleButtonGroup, ToggleButton, Box, Typography } from '@mui/material';
import GridViewIcon from '@mui/icons-material/GridView';
import ViewAgendaIcon from '@mui/icons-material/ViewAgenda';
import TabIcon from '@mui/icons-material/Tab';
import { colors } from '../theme/colors';

export type ViewMode = 'grid' | 'stacked' | 'tabs';

interface ViewModeSelectorProps {
  value: ViewMode;
  onChange: (mode: ViewMode) => void;
}

export const ViewModeSelector: React.FC<ViewModeSelectorProps> = ({ value, onChange }) => {
  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newMode: ViewMode | null,
  ) => {
    if (newMode !== null) {
      onChange(newMode);
      // Save to localStorage
      localStorage.setItem('plotViewMode', newMode);
    }
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <Typography
        variant="body2"
        sx={{
          color: colors.text.secondary,
          fontWeight: 500,
        }}
      >
        Режим отображения:
      </Typography>
      <ToggleButtonGroup
        value={value}
        exclusive
        onChange={handleChange}
        aria-label="режим отображения графиков"
        size="small"
        sx={{
          backgroundColor: colors.neutral[50],
          '& .MuiToggleButton-root': {
            border: `1px solid ${colors.neutral[200]}`,
            color: colors.text.secondary,
            '&.Mui-selected': {
              backgroundColor: colors.primary.main,
              color: colors.text.inverse,
              '&:hover': {
                backgroundColor: colors.primary.dark,
              },
            },
            '&:hover': {
              backgroundColor: colors.neutral[100],
            },
          },
        }}
      >
        <ToggleButton value="grid" aria-label="сетка">
          <GridViewIcon fontSize="small" sx={{ mr: 0.5 }} />
          Сетка
        </ToggleButton>
        <ToggleButton value="stacked" aria-label="стопкой">
          <ViewAgendaIcon fontSize="small" sx={{ mr: 0.5 }} />
          Стопкой
        </ToggleButton>
        <ToggleButton value="tabs" aria-label="вкладки">
          <TabIcon fontSize="small" sx={{ mr: 0.5 }} />
          Вкладки
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};
